export const checkInputValidity = (element: HTMLInputElement): boolean => {
    const disabledInput = element.disabled;
    element.disabled = false;
    // const valid = element.checkValidity();
    // reportValidity add varning
    const valid = element.reportValidity();
    if (disabledInput) {
        element.disabled = true;
    }
    return valid;
};

export const checkFormValidity = (
    // formRef: React.MutableRefObject<null>
    formRef: React.RefObject<HTMLFormElement>
): { [key: string]: boolean } => {
    const newErrors: { [key: string]: boolean } = {};

    if (formRef.current) {
        const currentElement: HTMLFormElement = formRef.current;

        const textareaList = Array.prototype.slice.call(currentElement.getElementsByTagName('textarea'));
        const inputsList = Array.prototype.slice.call(currentElement.getElementsByTagName('input'));
        const selectsList = Array.prototype.slice.call(currentElement.getElementsByTagName('select'));
        textareaList.concat(inputsList.concat(selectsList)).forEach((element) => {
            if (!checkInputValidity(element) && element.name) {
                newErrors[element.name] = true;
            }
        });
    }

    return newErrors;
};

type EditDataValueType = string | number | null | undefined | any;
export type EditDataType = { [key: string]: EditDataValueType };
export const getEditData = (data: EditDataType, keys: string[]): EditDataType => {
    const out: EditDataType = {};
    keys.map((key) => {
        out[key] = data[key];
    });
    return out;
};
